var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('div', {
    staticClass: "is-loading"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1) : _c('div', [_vm.styleType === 'unlimited' ? [_c('AppTimePicker', {
    attrs: {
      "placeholder": _vm.placeholder,
      "hasError": _vm.hasError,
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.handleInput
    },
    model: {
      value: _vm.time,
      callback: function callback($$v) {
        _vm.time = $$v;
      },
      expression: "time"
    }
  })] : [_vm.timeStyle == 'select_style' ? [_c('b-form-select', {
    staticClass: "form-control",
    staticStyle: {
      "border-width": "1px"
    },
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.handleInput
    },
    model: {
      value: _vm.time,
      callback: function callback($$v) {
        _vm.time = $$v;
      },
      expression: "time"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.placeholder))]), _vm._l(_vm.timeOptions, function (timeOption) {
    return _c('b-form-select-option', {
      key: timeOption.value,
      attrs: {
        "value": timeOption.value,
        "disabled": _vm.optionDisabler(timeOption.value)
      }
    }, [_vm._v(" " + _vm._s(_vm.timeOptionDisplayLabel(timeOption)) + " ")]);
  })], 2)] : _vm.timeStyle == 'button_style' ? [_c('div', {
    staticClass: "timer"
  }, _vm._l(_vm.timeOptions, function (timeOption) {
    return _c('label', {
      key: timeOption.value,
      staticClass: "time-option",
      class: {
        'selected': _vm.time === timeOption.value,
        'disabled': _vm.optionDisabler(timeOption.value)
      },
      on: {
        "click": function click($event) {
          return _vm.pickTime(timeOption.value);
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.time,
        expression: "time"
      }],
      staticClass: "time-input",
      attrs: {
        "type": "radio",
        "id": timeOption.value,
        "disabled": _vm.disabled
      },
      domProps: {
        "value": timeOption.value,
        "checked": _vm._q(_vm.time, timeOption.value)
      },
      on: {
        "change": function change($event) {
          _vm.time = timeOption.value;
        }
      }
    }), _vm._v(" " + _vm._s(_vm.timeOptionDisplayLabel(timeOption)) + " ")]);
  }), 0)] : _vm._e()]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }